import { useMemo } from 'react'

import { filterByEntity } from '@sales-center/common'
import { useAppSelector } from '@user/store/hooks'
import type { ENTITY_TYPES } from '@sales-center/common'
import {
  selectAllEntityAppointments,
  useGetEntityAppointmentsOnMount,
} from '@user/store/scheduling'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function useData(props: Props) {
  const { entityId, entityType } = props

  const status = useGetEntityAppointmentsOnMount(entityId, entityType)

  const allAppts = useAppSelector(selectAllEntityAppointments)

  const appointments = useMemo(
    () =>
      filterByEntity(allAppts, entityId, entityType).filter(
        ({ status }) => status !== 'Cancelled',
      ),
    [allAppts, entityId, entityType],
  )

  return {
    status,
    appointments,
  }
}
